import { push } from "connected-react-router";
import useSchema from "hooks/useSchema";
import { isEmpty } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { actions as creditBillActions } from "reducers/creditBills";
import * as Yup from "yup";

export const useTransmitForm = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const [npfcOptions, setNpfcOptions] = useState([]);
    const { actionData, beneficiaries, fetching } = useSelector((_state) => _state.creditBills);
    const { stringRequired } = useSchema();

    const initialValues = {
        cuit: actionData.cuit ?? "",
        beneficiaryCompanyName: actionData.beneficiaryCompanyName ?? "",
        transmissionType: actionData.transmissionType ?? "NOM",
        motive: actionData.motive ?? "",
        beneficiaryType: actionData.beneficiaryType ?? "",
    };

    const validationSchema = Yup.object().shape({
        cuit: stringRequired,
        transmissionType: stringRequired,
        motive: stringRequired,
        beneficiaryType: stringRequired,
    });

    const handleSubmit = useCallback(
        (values) => {
            const prepareData = {
                ...actionData,
                ...values,
            };
            dispatch(creditBillActions.setActionData(prepareData));
            dispatch(push("/creditBills/transmission/confirm"));
        },
        [actionData, dispatch],
    );

    useEffect(() => {
        if (actionData?.invoiceList?.length === 0 || isEmpty(actionData)) {
            history.goBack();
        }
    }, []);

    useEffect(() => {
        const transmissionType = "NOMINAL";
        dispatch(creditBillActions.getBeneficiaries(transmissionType));
    }, []);

    useEffect(() => {
        if (beneficiaries?.pnfc?.length > 0) {
            setNpfcOptions(beneficiaries.pnfc.map((item) => ({ value: item.cuit, label: item.razonSocial })));
        }
    }, [beneficiaries.pnfc]);

    return {
        handleSubmit,
        tabOption: actionData.tabOption,
        validationSchema,
        initialValues,
        bills: actionData.invoiceList,
        npfcOptions,
        fetching,
    };
};

export default useTransmitForm;
